// libs
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Card from '../../cards/card/Card';
import CardGrid from '../../cards/cardGrid/CardGrid';
import LinedTitle from '../../tools/linedTitle/LinedTitle';
import Suggestions from './Suggestions';

// Props and Context
const propTypes = {
  contentType: PropTypes.oneOf(['artwork', 'activity']).isRequired,
  resourcesFiles: PropTypes.array,
  resourcesVideos: PropTypes.array,
  suggestionsLinks: PropTypes.array,
  suggestionsMedias: PropTypes.array,
};
const defaultProps = {
  resourcesFiles: [],
  resourcesVideos: [],
  suggestionsLinks: [],
  suggestionsMedias: [],
};
const contextTypes = {
  t: PropTypes.func,
};

function Resources({
  contentType,
  resourcesFiles,
  resourcesVideos,
  suggestionsLinks,
  suggestionsMedias,
}, { t }) {
  const cardGridSettings = {
    arrows: false,
    dots: true,
    slidesToShow: 2,
    infinite: false,
    responsive: [
      {
        breakpoint: 608,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  if (
    resourcesFiles.length === 0 &&
    resourcesVideos.length === 0 &&
    suggestionsLinks.length === 0 &&
    suggestionsMedias.length === 0
  ) {
    return null;
  }
  return (
    <div className="section__wrapper">
      {resourcesFiles.length > 0 &&
        <div className="annex annex--files">
          <h5 className="annex__heading">{t('pages.single.resources.files')}</h5>
          <div className="grid">
            <CardGrid
              sliderBreakpoint={767}
              settings={cardGridSettings}
            >
              {resourcesFiles.map((resource) =>
                <div className="grid__item" key={`resourceCard-${resource.slug}-${resource.id}`}>
                  <Card
                    {...resource}
                  />
                </div>,
              )}
            </CardGrid>
          </div>
        </div>
      }
      {resourcesVideos.length > 0 &&
        <div className="annex annex--videos">
          <LinedTitle
            title={t(`pages.${contentType}.resourcesHeader.title`)}
            description={t(`pages.${contentType}.resourcesHeader.description`, { n: t(`pages.single.contentType.${contentType}`) })}
          />
          <h5 className="annex__heading">{t('pages.single.resources.videos')}</h5>
          <div className="grid">
            <CardGrid
              sliderBreakpoint={767}
              settings={cardGridSettings}
            >
              {resourcesVideos.map((resource) =>
                <div className="grid__item" key={`video-${resource.slug}-${resource.id}`}>
                  <Card
                    {...resource}
                  />
                </div>,
              )}
            </CardGrid>
          </div>
        </div>
      }
      {(suggestionsLinks.length > 0 || suggestionsMedias.length > 0) &&
        <Suggestions links={suggestionsLinks} medias={suggestionsMedias} />
      }
    </div>
  );
}

Resources.propTypes = propTypes;
Resources.defaultProps = defaultProps;
Resources.contextTypes = contextTypes;

export default Resources;



// WEBPACK FOOTER //
// ./src/app/components/singles/parts/Resources.js